export enum CategorizationPopulationMode {
  Default = 0,
  PopulateAllLevel2 = 1
}
